import GlobeSvg from '@assets/images/svg/globe.svg';
import React from 'react';
import { StyleSheet, View } from 'react-native';

export function GlobeIcon({ size = 24, color = '#333333' }: { size?: number, color?: string }) {
    return (
        <View style={[styles.container, { width: size, height: size }]}>
            <GlobeSvg
                width={size}
                height={size}
                color={color}
            />
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    },
});

export default GlobeIcon;